import * as React from 'react';
import { Navigation } from '../../navigation/navigation';
import { AccountBox } from '../../account-box/account-box';
import { routes } from '../../../../config/routes';
import { PortfolioSwitcher } from '../../../../components/app/portfolio/switcher/portfolio-switcher';
import { Logo } from '../../../../components/app/logo/logo';

export const HeaderVertical: React.FC = () => {
    return (
        <div className="z-[900] flex items-center justify-between border-b border-border bg-surface/90 px-medium backdrop-blur-[0.5rem]">
            <div className="flex items-center gap-xsmall md:gap-vsmall">
                <Logo href={routes.app.index} inApp />
                <div className="relative h-auto w-[0.1rem] self-stretch bg-border" />
                <PortfolioSwitcher />
            </div>
            <Navigation />
            <AccountBox />
        </div>
    );
};
